export const AGGREGATED_SEARCH_COUNT = 10

export const MIN_SEGMENT_LENGTH_SECONDS = 10 // API minimum segment length
export const MAX_SEGMENT_LENGTH_SECONDS_AIMS = 60 // AIMS API maximum segment length
export const DEFAULT_SEGMENT_START = 30
export const DEFAULT_SEGMENT_END =
  DEFAULT_SEGMENT_START + MAX_SEGMENT_LENGTH_SECONDS_AIMS
export const SEGMENT_KEYBOARD_STEP = 1 // seconds moved per ArrowLeft/ArrowRight keypress
export type SearchType = 'track' | 'playlist' | 'album' | 'artist' | 'channel'

export const SEARCH_SOURCE_COLUMN_FIELD = 'Source'

export const SEARCH_APPEARS_ON_COLUMN_FIELD = 'AppearsOn'

export const SEARCH_APPEARS_ON_FILTER_FIELD = 'track_playlists_count'

export const SEARCH_TITLE_COLUMN_FIELD = 'Title'

// Underscore-prefixed so this reserved column can never collide with a
// business's custom metadata field of the same display name. Keep it a valid
// CSS ident fragment — DataTable emits `--col-<id>-size` from it.
export const SEARCH_INDICATORS_COLUMN_FIELD = '_indicators'

export const SEARCH_TRACK_TAGS_FILTER_FIELD = 'track_tags'

/**
 * Columns that stay hidden until the user explicitly turns them on.
 * Column visibility treats a missing key as visible, so newly registered
 * columns would otherwise appear unannounced in saved layouts that predate
 * them. The search-page reducer backfills these fields to hidden instead.
 */
export const OPT_IN_HIDDEN_COLUMN_FIELDS = [SEARCH_INDICATORS_COLUMN_FIELD]

/**
 * Filter-definition field name for the source filter. Lowercase because it is
 * a routing-only key: it identifies the source filter inside the filter-definition
 * layer but is never rendered as a chip and is never forwarded into the v2
 * request's `filters` block — it is translated into the top-level `scope`
 * payload instead. Keep lowercase to avoid colliding with display-cased column
 * field names like `SEARCH_SOURCE_COLUMN_FIELD`.
 */
export const SOURCE_FILTER_FIELD = 'source'

/** Display label for Multi-DISCO Search tracks when no business name is available. */
export const SEARCH_MDS_DISPLAY_NAME = 'MultiDISCO Search'

/** Display label for business-scoped (user's own) tracks in the source column. */
export const SEARCH_MY_DISCO_DISPLAY_NAME = 'My DISCO'

/**
 * Source-scope runtime values. The `SourceScope` type is derived from this
 * object (`typeof SOURCE_SCOPE[keyof typeof SOURCE_SCOPE]`) so the runtime
 * constants and the compile-time union stay in lockstep — adding a new scope
 * here automatically widens the type, and removing one is a type error at
 * every consumer. Do not duplicate these literals as a hand-written union.
 */
export const SOURCE_SCOPE = {
  BUSINESS: 'business',
  MDS: 'mds',
} as const

// How many columns are visible by default in the search results table
// (applies until the user customizes their columns).
export const DEFAULT_VISIBLE_COLUMN_COUNT = 12

// Column order for the search results table.
export const defaultColumnSorting = [
  'Title',
  SEARCH_INDICATORS_COLUMN_FIELD,
  SEARCH_APPEARS_ON_COLUMN_FIELD,
  'Artist',
  SEARCH_SOURCE_COLUMN_FIELD,
  'Duration',
  'Waveform',
  'NativeTags',
]
